// chartTheme.js

export const chartOptionsTheme = {
  light: {
    palette: {
      text: {
        primary: '#000',
        secondary: '#555',
      },
      grid: 'rgba(0,0,0,0.1)',
      tooltip: {
        bg: '#fff',
        title: '#000',
        body: '#111',
        border: '#ccc',
      },
    },
  },
  dark: {
    palette: {
      text: {
        primary: '#fff',
        secondary: '#aaa',
      },
      grid: 'rgba(255,255,255,0.1)',
      tooltip: {
        bg: '#333',
        title: '#fff',
        body: '#ddd',
        border: '#555',
      },
    },
  },
};
